import { createContext } from 'react';
import { standardColor } from './colorPalettes';

export const ColorPaletteContext = createContext({
  colorPalette: standardColor,
  cycleColorPalette: () => {},
  currentPaletteIndex: 0,
});

export const ColorPaletteContextProvider = ColorPaletteContext.Provider;